import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Verdieping", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Ruimte", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Groep", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Element", -1)

import { completionTwoStore } from '@/stores/completionTwo'
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue'
import { generalStore } from '@/stores/general'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Completion2Menu',
  setup(__props) {

const currentGroup = computed(() => {
  return completionTwoStore().groups.find(g => g.id === completionTwoStore().current.group) || null
})

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,4] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 5}
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_a_select, {
            style: {"width":"100%"},
            "list-height": 512,
            value: _unref(completionTwoStore)().current.level,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(completionTwoStore)().current.level) = $event)),
            loading: _unref(completionTwoStore)().loading.levels,
            disabled: _unref(completionTwoStore)().menuDisabled,
            onChange: _unref(completionTwoStore)().setLevel
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(completionTwoStore)().levels, (level) => {
                return (_openBlock(), _createBlock(_component_a_select_option, {
                  value: level.id,
                  key: level.id
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(level.name), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value", "loading", "disabled", "onChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 5}
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createVNode(_component_a_select, {
            style: {"width":"100%"},
            "list-height": 512,
            value: _unref(completionTwoStore)().current.room,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(completionTwoStore)().current.room) = $event)),
            loading: _unref(completionTwoStore)().loading.rooms,
            disabled: _unref(completionTwoStore)().menuDisabled,
            onChange: _unref(completionTwoStore)().setRoom
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(completionTwoStore)().rooms, (room) => {
                return (_openBlock(), _createBlock(_component_a_select_option, {
                  value: room.id,
                  key: room.id
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(room.level) + "." + _toDisplayString(room.position) + " - " + _toDisplayString(room.name), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value", "loading", "disabled", "onChange"])
        ]),
        _: 1
      }),
      (!_unref(completionTwoStore)().emptyLayout)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            xs: {span: 24},
            sm: {span: 24},
            md: {span: 24},
            lg: {span: 5}
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_a_select, {
                style: {"width":"100%"},
                "list-height": 512,
                value: _unref(completionTwoStore)().current.group,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(completionTwoStore)().current.group) = $event)),
                loading: _unref(completionTwoStore)().loading.groups,
                disabled: _unref(completionTwoStore)().menuDisabled,
                onChange: _unref(completionTwoStore)().setGroup
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(completionTwoStore)().groups, (group) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: group.id,
                      key: group.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(group.description), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "loading", "disabled", "onChange"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_unref(completionTwoStore)().emptyLayout)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 1,
            xs: {span: 24},
            sm: {span: 24},
            md: {span: 24},
            lg: {span: 5}
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createVNode(_component_a_select, {
                style: {"width":"100%"},
                value: _unref(completionTwoStore)().current.elementIndex,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(completionTwoStore)().current.elementIndex) = $event)),
                loading: _unref(completionTwoStore)().loading.elements,
                disabled: _unref(completionTwoStore)().menuDisabled,
                onChange: _unref(completionTwoStore)().setElement
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(completionTwoStore)().elements, (element, index) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: index,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        (_unref(currentGroup) && [70, 30].includes(_unref(currentGroup).number))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(element.position) + ". " + _toDisplayString(element.name_sales), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(element.name_sales), 1)
                            ], 64))
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "loading", "disabled", "onChange"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(completionTwoStore)().elements.length)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 2,
            xs: {span: 24},
            sm: {span: 24},
            md: {span: 24},
            lg: {span: 4}
          }, {
            default: _withCtx(() => [
              _createElementVNode("label", {
                style: _normalizeStyle(_unref(generalStore)().desktop ? { width: '100%', display: 'block', textAlign: 'right' } : { width: '100%', display: 'block', textAlign: 'left' })
              }, _toDisplayString(_unref(completionTwoStore)().current.elementIndex + 1) + " van " + _toDisplayString(_unref(completionTwoStore)().elements.length), 5),
              (_unref(generalStore)().desktop)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    style: {"float":"right","margin-left":"4px"},
                    disabled: _unref(completionTwoStore)().menuDisabled || (_unref(completionTwoStore)().current.elementIndex + 1) === _unref(completionTwoStore)().elements.length,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(completionTwoStore)().setElement(_unref(completionTwoStore)().current.elementIndex + 1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(RightOutlined))
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (_unref(generalStore)().desktop)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    style: {"float":"right"},
                    disabled: _unref(completionTwoStore)().menuDisabled || _unref(completionTwoStore)().current.elementIndex === 0,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(completionTwoStore)().setElement(_unref(completionTwoStore)().current.elementIndex - 1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(LeftOutlined))
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (!_unref(generalStore)().desktop)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 2,
                    disabled: _unref(completionTwoStore)().menuDisabled || _unref(completionTwoStore)().current.elementIndex === 0,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(completionTwoStore)().setElement(_unref(completionTwoStore)().current.elementIndex - 1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(LeftOutlined))
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (!_unref(generalStore)().desktop)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 3,
                    type: "primary",
                    style: {"margin-left":"4px"},
                    disabled: _unref(completionTwoStore)().menuDisabled || (_unref(completionTwoStore)().current.elementIndex + 1) === _unref(completionTwoStore)().elements.length,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(completionTwoStore)().setElement(_unref(completionTwoStore)().current.elementIndex + 1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(RightOutlined))
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})